<template>
    <div class="w-full rounded-xl border border-gdc-gray-200">
        <div class="w-full px-4 py-4 flex-col lg:flex lg:flex-row">
            <div class="inline-flex w-full items-center">
                <img :src="logo" alt="" class="h-8 w-8"/>
                <h3 class="m-0 pl-2">Team Stats</h3>
            </div>
            <div class="flex-col lg:flex-row lg:inline-flex w-full lg:w-[50%] lg:items-center">
                <h3 class="m-0 pr-2">Season</h3>
                <select v-model="currentSeasonIndex" class="select">
                    <option v-for="(item, index) in this.stats" :value="index" selected="selected">
                        {{ item.season }}
                    </option>
                </select>
            </div>
        </div>
        <div class="w-full">
            <div class="w-full flex p-4 py-3 border-t border-b border-gdc-gray-opaque-200">
                <div class="w-full text-left">Offence</div>
                <div class="w-full text-center font-bold"></div>
                <div class="w-full text-right">Defence</div>
            </div>
            <div class="w-full flex p-4 py-3 border-gdc-gray-opaque-200">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence.total_yards }}</div>
                <div class="w-full text-center font-bold">Total YDS</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence.total_yards }}</div>
            </div>
            <div class="w-full flex p-4 py-3 border-t border-b border-gdc-gray-opaque-200 bg-gdc-gray-100">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence.passing_yards }}</div>
                <div class="w-full text-center font-bold">Passing Yards</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence.passing_yards }}</div>
            </div>
            <div class="w-full flex p-4 py-3 border-gdc-gray-opaque-200">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence.average_passing_yards }}</div>
                <div class="w-full text-center font-bold">Passing Yards Per Game</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence.average_passing_yards }}</div>
            </div>
            <div class="w-full flex p-4 py-3 border-t border-gdc-gray-opaque-200 bg-gdc-gray-100">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence['rushing--yards'] }} </div>
                <div class="w-full text-center font-bold">Rushing Yards</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence['rushing--yards'] }}</div>
            </div>
            <div class="w-full flex p-4 py-3 border-t border-b border-gdc-gray-opaque-200">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence['average_rushing_yards'] }}</div>
                <div class="w-full text-center font-bold">Rushing Yards Per Game</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence['average_rushing_yards'] }}</div>
            </div>
            <div class="w-full flex p-4 py-3 bg-gdc-gray-100 rounded-b-xl">
                <div class="w-full text-left">{{ this.selectedSeason.stats.offence['first_downs--total'] }}</div>
                <div class="w-full text-center font-bold">Total First Downs</div>
                <div class="w-full text-right">{{ this.selectedSeason.stats.defence['first_downs--total'] }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'nfl-team-stats',
    props: {

        logo: {
            type: String,
            required: true,
        },

        stats: {
            type: Array,
            required: true,
        },

        translations: {
            type: Object,
            required: true,
        },
    },

    data: function ()
    {
        return {
            currentSeasonIndex: 0,
            selectedSeason: this.stats[0],
        }
    },

    watch: {
        currentSeasonIndex()
        {
            this.selectedSeason = this.stats[this.currentSeasonIndex]
        }
    },
}
</script>
<style lang="scss" scoped>
    .select
    {
        -webkit-appearance: none;
        -moz-appearance: none;
        background-position-x: 95%;
        background-position-y: 50%;
        background: transparent url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill='%23888'%3E%3Cpath d='m0 6 12 12L24 6H0z'/%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3C/svg%3E") no-repeat;
        background-size: 10px;
        border: 1px solid #dfdfdf;
        padding: 1rem;
        width: 100%;
        border-radius: 10px;
        border: 1px solid rgba(51, 51, 51, 0.25);
    }
</style>
